(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mwm-hero"] && !Shopify.designMode) return;
  try {
    
  // Custom-element lifecycle also handles theme-editor section replacement.
  if (!customElements.get('mwm-background-hero')) {
    customElements.define('mwm-background-hero', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.listeners) return;
        this.video = this.querySelector('.mwm-hero__background-video');
        this.controls = this.querySelector('.mwm-hero__video-controls');
        this.button = this.querySelector('.mwm-hero__video-toggle');
        if (!this.video || !this.controls || !this.button) return;

        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.userPlayback = null; // null = automatic, false = paused by visitor.
        this.autoplayBlocked = false;
        this.failed = false;
        this.pendingPlay = null;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;

        this.button.addEventListener('click', () => {
          this.userPlayback = this.video.paused && !this.pendingPlay;
          this.autoplayBlocked = false;
          this.applyPlayback();
        }, options);

        this.video.addEventListener('playing', () => {
          if (!this.shouldPlay) {
            this.video.pause();
            return;
          }
          this.setAttribute('data-video-ready', '');
          this.updateButton();
        }, options);
        this.video.addEventListener('play', () => this.updateButton(), options);
        this.video.addEventListener('pause', () => this.updateButton(), options);
        this.video.addEventListener('error', () => {
          this.failed = true;
          this.removeAttribute('data-video-ready');
          this.applyPlayback();
        }, options);

        this.motionQuery.addEventListener('change', () => {
          // A newly changed accessibility preference takes priority.
          this.userPlayback = null;
          this.applyPlayback();
        }, options);
        this.mobileQuery.addEventListener('change', () => this.applyPlayback(), options);
        document.addEventListener('visibilitychange', () => this.applyPlayback(), options);
        this.applyPlayback();
      }

      applyPlayback() {
        if (!this.video || !this.listeners) return;
        const mobileDisabled = this.dataset.videoMobile === 'false' && this.mobileQuery.matches;
        const reducedMotion = this.motionQuery.matches && this.userPlayback !== true;
        this.toggleAttribute('data-video-suppressed', mobileDisabled || reducedMotion || this.failed);
        this.controls.hidden = mobileDisabled || this.failed;
        this.shouldPlay = !mobileDisabled && !reducedMotion && !this.failed &&
          !document.hidden && this.userPlayback !== false && !this.autoplayBlocked;

        if (this.shouldPlay) {
          this.playVideo();
        } else {
          this.video.pause();
        }
        this.updateButton();
      }

      playVideo() {
        if (this.pendingPlay || !this.video.paused) return;
        const controller = this.listeners;
        this.video.muted = true;
        const playResult = this.video.play();
        if (playResult && typeof playResult.catch === 'function') {
          this.pendingPlay = playResult;
          playResult.catch((error) => {
            if (controller.signal.aborted) return;
            // Blocking autoplay is normal on some devices. Leave a Play button.
            if (error.name !== 'AbortError') this.autoplayBlocked = true;
          }).finally(() => {
            if (controller.signal.aborted) return;
            this.pendingPlay = null;
            this.updateButton();
          });
        }
      }

      updateButton() {
        if (!this.button || !this.video) return;
        const playing = !this.video.paused && !this.video.ended;
        this.button.textContent = playing
          ? (this.dataset.pauseLabel || 'Pause background video')
          : (this.dataset.playLabel || 'Play background video');
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.listeners) this.listeners.abort();
        if (this.video) this.video.pause();
        this.listeners = null;
        this.pendingPlay = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
